import { ButtonLinkFieldViewModel } from '@/src/shared/presentation/view-models/button-link-field.viewModel';
import { ImageViewModel } from '@/src/shared/presentation/view-models/image.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type {
  PartnershipBannerBlock,
  PartnershipBannerBlockDisplay,
  PartnershipBannerBlockTheme
} from '@/src/cms/domain/models/blocks/partnership-banner-block';

export class PartnershipBannerBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'partnership-banner-block' as const;

  hide: boolean;
  title: string;
  theme: PartnershipBannerBlockTheme;
  isH1: boolean;
  display: PartnershipBannerBlockDisplay;
  items: string[];
  buttonLink: ButtonLinkFieldViewModel;
  media: ImageViewModel | null = null;

  constructor(data: {
    hide: boolean;
    title: string;
    theme: PartnershipBannerBlockTheme;
    isH1: boolean;
    display: PartnershipBannerBlockDisplay;
    items: string[];
    buttonLink: ButtonLinkFieldViewModel;
    media: ImageViewModel | null;
  }) {
    this.hide = data.hide;
    this.title = data.title;
    this.theme = data.theme;
    this.isH1 = data.isH1;
    this.display = data.display;
    this.items = data.items;
    this.buttonLink = data.buttonLink;
    this.media = data.media;
  }

  static presenter(block: PartnershipBannerBlock): PartnershipBannerBlockViewModel {
    return new PartnershipBannerBlockViewModel({
      hide: block.hide,
      title: block.title,
      theme: block.theme,
      isH1: block.isH1,
      display: block.display,
      items: block.items,
      buttonLink: ButtonLinkFieldViewModel.presenter(block.buttonLink),
      media: block.media ? ImageViewModel.presenter(block.media) : null
    });
  }
}
